<template>
  <div>
      <Header title="我的免修申请"></Header>
      <div class="delay-search">
        <i class="search-icon" @click="searchMy()"></i>
        <input type="text" placeholder="搜索课程(名称或课号)" v-model="courseInfo">
      </div>
      <div class="search-info">
        <div class="sem-drop">
          <div @click="semPicker = true"><p>{{this.semester}}</p><i></i></div>
          <div @click="actTap()"><p>{{this.activity}}</p><i></i></div>
        </div>
        <van-popup v-model="semPicker" position="bottom">
          <van-picker show-toolbar :columns="option1" @cancel="semPicker = false" @confirm="semConfirm" :swipe-duration="500" :item-height="35"/>
        </van-popup>
        <van-popup v-model="actPicker" position="bottom">
          <van-picker show-toolbar :columns="option2" @cancel="actPicker = false" @confirm="actConfirm" :swipe-duration="500" :item-height="35"/>
        </van-popup>
        <!-- <van-dropdown-menu>
          <van-dropdown-item v-model="value1" :options="option1" @change="itemSelect"/>
          <van-dropdown-item v-model="value2" :options="option2" @open="courseShow"/>
        </van-dropdown-menu> -->
      </div>
      <NOdata title="未查询到免修申请~" v-if="this.allWarnList.length == 0 && isLoad"></NOdata>
      <template v-else>
        <a class="grey-contain" v-for="(item,index) in allWarnList" :key="index" @click="goDetail(index)">
          <div>
            <p class="contain-txt">{{item.coursename}}</p>
            <p class="contain-txt1">考试方式：{{item.ksfs}}</p>
            <p class="contain-txt1">申请时间：{{item.sqsj}}</p>
          </div>
          <p :style="item.shzt == '通过' ? 'color: #12DDD6;' : 'color:#F86969;'">{{item.shzt}}</p>
        </a>
      </template>
  </div>
</template>

<script>
import { Api } from '../../../utils/axios'
  export default {
    data() {
      return {
        courseInfo:'',
        semPicker:false,
        actPicker:false,
        semester:'学年学期',
          curSemester:'',
        activity:'活动名称',
        allWarnList:[],
        timeValue: '',
        activityValue:'',
        value2: 0,
        option1: [{
          text:'学年学期',
          value:0,
          index:''
        }],
        option2: [{
          text:'活动名称',
          value:0,
          index:''
        }],
        activityId:'',
        isLoad:false,
          mxfs:[]
      }
    },
        created(){
          this.getMain()
          this.getSemList()
        },
        methods:{
          async getSemList(){
            let concatList = []
            const res = await Api.getSemesterList()
            res.data.forEach((item,index) => {
              concatList[index] = {
                text:item.semesterName,
                value:index + 1,
                index:item.semesterId
              }
            });
            this.option1 = this.option1.concat(concatList)
          },
          async getMain(){
            const res = await Api.getCurrentTerm()
            this.semester = res.data[0].semesterId
            this.curSemester = res.data[0].semesterId
            this.getSlow(res.data[0].semesterId)
            this.itemSelect(res.data[0].semesterId)
          },
          async getSlow(val){
            const params = {
              semester:val,
              xx0101id:sessionStorage.getItem("schoolCode"),
              courseName: '',
              cj0701id: '',
                type:"myMxlist"
            }
            const res = await Api.getExemptExam(params)
            this.allWarnList = res.data;
            this.mxfs=res.mxfs;
            this.isLoad = true;
          },
          actTap(){
            if(this.semester == '' || this.semester == '学年学期'){
              this.$toast.fail('请先选择学年学期')
            }else{
              this.actPicker = true
            }
          },
          semConfirm(e,val){
            this.semPicker = false
            this.semester = e.text
              if(this.semester == '' || this.semester == '学年学期'){
                  this.semester = this.curSemester
              }
            this.searchMy()
            this.itemSelect(this.semester)
          },
          actConfirm(e,val){
            this.actPicker = false;
            this.activity = e.text
            this.activityId = e.index
            this.searchMy()
          },
          goDetail(index){
            this.$router.push({
              path:'/student/myExemptApply1',
              query:{
                'data':JSON.stringify(this.allWarnList[index]),
                'mxfs':JSON.stringify(this.mxfs)
              }
            })
          },
          courseShow(res){
            if(this.value1 == ''){
              this.$toast.fail('请先选择学年学期~')
            }
          },
          async itemSelect(index){
            this.option2 = [{
              text:'活动名称',
              value:0,
              index:''
            }]
            this.value2 = 0
            const params = {
              semester:index
            }
            const res = await Api.getActivityName(params)
            let concatList = []
            res.data.forEach((item,index) => {
              concatList[index] = {
                text:item.activityname,
                value:index + 1,
                index:item.cj0701id
              }
            });
            this.option2 = this.option2.concat(concatList)
          },
          async searchMy(){
            const params = {
              semester:this.semester == '学年学期' ? '' : this.semester,
              courseName:this.courseInfo,
              cj0701id:this.activityId == '活动名称' ? '' : this.activityId,
              xx0101id:sessionStorage.getItem("schoolCode"),
                type:"myMxlist"
            }
            const res = await Api.getExemptExam(params)
            this.allWarnList = res.data
            this.mxfs=res.mxfs;
          }
        },
      }
</script>

<style lang="less" scoped>
  .delay-search{
    background-color: @attendance-background-color-6;
    border-radius:3px;margin: 20px 20px 0;
    padding: 11px 12px;display: flex;
    .search-icon{
      background: url(../../../../static/img/search.png)no-repeat center;
      width: 22px;height: 22px;background-size: 22px 22px;
    }
    input{
      background-color: @attendance-background-color-6;
      padding-left: 22px;flex: 1;color: @attendance-color-2;
    }
  }
  .search-info{
    display: flex;justify-content: center;
    border-bottom: 1px solid @attendance-border-color-6;
    padding: 20px 0 7px;
    .sem-drop{
      display: flex;
      width:90%;
      >div{
        display: flex;align-items: center;color: @attendance-color-2;font-size: 14px;
        justify-content: center;
        width: 45%;
        i{
          background: url(../../../../static/img/Triangle.png)no-repeat center;
          width: 10px;height: 10px;background-size: 10px 8px;margin-left: 5px;
        }
      }
    }
  }
  .grey-contain{
    >p{
      font-size: 14px;font-weight: 500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/student/exemptTest/myExemptApply.vue